var JANE = {
  
  	server_url : 'https://22918.aumanaged.com/janeiredale/',
  
  	store_url : 'https://janeiredale.com.au/',
  
	user_email: '',

	current_page : 1,

	container : '#jane-iredale-questionnaire-app',

	trigger_element : 'a[data-id="quiz-modal-trigger"]',
  
	main_nav_container : '.main-menu',

	page_4_opt : [

		{
			label : 'FAIR',
			color : '#f0d8c4',
			options : [

				'#F0D8B6',
				'#eedac4',
				'#e4cdb4'

			]
		},

		{
			label : 'LIGHT',
			color : '#eccfb4',
			options : [

				'#f0d8b9',
				'#eedac4',
				'#e4cdb4'

			]
		},

		{
			label : 'LIGHT TO MEDIUM',
			color : '#e6c9b4',
			options : [

				'#f8dac2,#efcda2',
				'#ead0b4',
				'#e4cdb4'

			]
		},

		{
			label : 'MEDIUM',
			color : '#e5c4ab',
			options : [

				'#ebcba0',
				'#e2c5ac',
				'#e9c9b6'

			]
		},

		{
			label : 'MEDIUM TO DARK',
			color : '#d7ba96',
			options : [

				'#d4ab78',
				'#d7bb96',
				'#d8a46f'

			]
		},

		{
			label : 'DARK',
			color : '#cb9e73',
			options : [

				'#e3a86c,#d9a479',
				'#E1AE7E',
				'#bf9468'

			]
		},

		{
			label : 'VERY DARK',
			color : '#ba8556',
			options : [

				'#c4906b,#cb8c59',
				'#b88659',
				'#b27a65'

			]
		},

		{
			label : 'DEEP',
			color : '#a8805d',
			options : [

				'#a8805d',
				'#865b3f',
				'#9a6c57'

			]
		},

	],

	init : function() {
      
        var trigger_el = '<li class="child kids-0"><a href="#" class="nav-link" data-id="quiz-modal-trigger">Foundation Finder</a></li>';
        $(this.main_nav_container).append(trigger_el);

		this.container = $(this.container);

		this.render_page_4_opt();

		this.toggle_bg_img();

		this.update_page_indicator();

		this.bind();

		if(this.get_url_var('ji_force_email') === '1') {

			this.goto_page(0);

		}
      
      	if(this.get_url_var('ji_auto_display') === '1') {

			JANE.container.show();

		}

		//this.goto_page(0);

	},

	bind : function() {

		$(this.trigger_element).on('click', function() {

			JANE.container.toggle();

		});

		$('.ji-close-btn').on('click', function() {

			JANE.container.hide();

		});

		JANE.container.on('click', function() {

			$(this).toggle();

		});
      
        $(document).on('click', '[href="#foundation-quiz"]', function (e) {
            e.preventDefault();

            JANE.container.show();
        });

        $(document).on('click', '[href="#foundation-quiz-email"]', function (e) {
            e.preventDefault();

            JANE.goto_page(0);
            JANE.container.show();
        });


		$('.ji-container').on('click', function(e) {

			e.stopPropagation();

		});


		$('.ji-advice-btn').on('click', function() {

			JANE.toggle_advice_content();

		});


		$('.ji-page-indicator li').on('click', function() {

			var page_num = $(this).data('page');

			JANE.goto_page(page_num);

		});


		$('.ji-skin-tone-opt').on('click', 'li', function() {

			JANE.toggle_page_4_opt(this);

		});


		$('.ji-btn-start-over, .ji-header > span').on('click', function() {

			JANE.goto_page(1);

			JANE.reset_user_input();

		});


		$('.ji-product-result').on('click', 'div', function() {

			JANE.toggle_selected_product(this);

		});


		$('.ji-btn-add2cart').on('click', function() {

			JANE.add_items_to_cart();

		});


		$('.ji-skin-type, .ji-finish-opt, .ji-coverage-opt, .ji-skin-tone-opt, .ji-skin-tone-sub-opt').on('click', 'li', function(e) {

			e.stopPropagation();

			var class_names = [
				'ji-skin-type',
				'ji-finish-opt',
				'ji-coverage-opt',
				'ji-skin-tone-opt',
				'ji-skin-tone-sub-opt'
			];

			var q_num = 0;

			var li = $(this);
			var ul = li.closest('ul');

			$.each(class_names, function(key, class_name) {

				if(ul.hasClass(class_name)) {

					q_num = key + 1;

				}

			});

			JANE.update_user_input(q_num, li.data('index'));

			if(q_num !== 4) {

				JANE.move_page_right();

			}

		});

        $('#ji-subscribe-form, #ji-email-results-form').on('keyup change', 'input', function(e) {

            JANE.validate_ji_form(this, e);

        });

        $('#ji-subscribe-form button').on('click', function() {

            var _ = $(this);

            var is_disabled = _.attr('disabled');

            if(typeof is_disabled !== typeof undefined && is_disabled !== false || !_.prop('disabled') ) {

              JANE.user_email = _.siblings('input').val();
              
              $.post(JANE.server_url+'add_email_to_mc.php', {'email_address' : JANE.user_email}, JANE.add_email_to_mc);


            } else {

              //console.log('disbaled');

            }

        });

        $('#ji-email-results-form button').on('click', function() {
          
          	JANE.set_loading_bar(30);

            var _ = $(this);

            var is_disabled = _.attr('disabled');

            if(typeof is_disabled !== typeof undefined && is_disabled !== false || !_.prop('disabled') ) {
              
              JANE.set_loading_bar(40);
              
              var selected_opt = '';
              var prevent_user = false;

              $('#ji-user-input input[name^="q-"]').each(function(key, item) {
                
                  JANE.set_loading_bar(40 + (key*5));

                  if($(this).val() == 0) {

                      prevent_user = true;
                      JANE.goto_page(parseInt($(this).data('nth-question')));
                      return false;

                  } else {

                      selected_opt += $(this).val() + '-';

                  }

              });

              if(prevent_user) {
                
                JANE.set_loading_bar(100);
                return;
              
              }

              selected_opt = selected_opt.substr(0, selected_opt.length-1);
              
              //send user an the results
              $.post(JANE.server_url+'send_results_to_user.php', {'email' : _.siblings('input').val(), 'selected_opt' : selected_opt}, function(res) {
                
                var _ = $('#ji-email-results-form p');
                  
                  _.html('An email has been sent to <b>' + _.siblings('input').val() + '</b>');
                
                JANE.set_loading_bar(100);
              
              });

            } else {

              //console.log('disbaled');

            }

        });

	},

	toggle_modal : function() {



	},

	set_loading_bar : function(percentage = 0) {
      
      	var value = 100 - percentage;
      
      	var loading_bar = $('.ji-loading-bar');

		loading_bar.css('right', value + '%');
      
      	if(value === 0) {
      
            setTimeout(function() {

                  loading_bar.css('right', '100%')

            }, 1000);
        
      	}

	},

    add_email_to_mc : function(res) {

        if(res !== 'false') {

           	JANE.goto_page(1);

        } else {

          	$('#ji-subscribe-form p').html('<b>Invalid email address. Please try again<b>');

    	}

    },
      
      
    validate_ji_form : function(_this, e) {

        var valid_email = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;

        var _ = $(_this);

        if(valid_email.test(_.val())) {

         	 _.siblings('button').prop('disabled', false).removeAttr('disabled');
	
        } else {

          	_.siblings('button').prop('disabled', true).attr('disabled', 'disabled');

        }

        if (e.keyCode == 13) {
          
          	_.siblings('button').click();
          
        }

    },

	toggle_advice_content : function() {

		var advice_content = $('.ji-advice-content');
		var ji_content = $('.ji-content');
		var height = '60px';

		if(advice_content.height() === 0) {

			advice_content.css('height', height);
			ji_content.css({

				'padding-top': '0px',
				'margin-top': height

			});

		}
		else {

			advice_content.css('height', '0px');
			ji_content.css({

				'padding-top': height,
				'margin-top': '0px'

			});

		}

	},

	on_page_move : function() {

		switch(this.current_page) {
            
          	case 4:
            
                $('.ji-skin-tone-opt .expanded').removeClass('expanded');
            	break;

			case 5:
            
            	$('.ji-page-5 #no-products-found, .ji-page-5 #products-found').hide();

				this.find_products();
            
            	$('#ji-email-results-form input').val(JANE.user_email).trigger('change');
            
				break;

			//default: break;

		}

	},

	move_page_right : function() {

		$('.ji-page-' + this.current_page.toString()).css('left', '-100%');

		this.current_page++;

		$('.ji-page-' + this.current_page.toString()).css('left', '0px');

		this.toggle_bg_img();

		this.update_page_indicator();

		this.on_page_move();

	},

	move_page_left : function() {

		$('.ji-page-' + this.current_page.toString()).css('left', '100%');

		this.current_page--;

		$('.ji-page-' + this.current_page.toString()).css('left', '0px');

		this.toggle_bg_img();

		this.update_page_indicator();

		this.on_page_move();

	},

	update_page_indicator : function() {

		$('.ji-page-indicator li').removeClass('completed active');

		$('.ji-page-indicator li').each(function(key, elm) {

			if(key < JANE.current_page) {

				$(this).addClass('completed');

			} else if(key === JANE.current_page) {

				$(this).addClass('active');

			}

		});

		if(this.current_page === 0) {

			$('.ji-page-indicator, .ji-header > span').hide();

		} else {

			$('.ji-page-indicator, .ji-header > span').show();

		}
	},

	toggle_bg_img : function() {

		var container = $('.ji-container');

		switch(this.current_page) {

			case 1:
				container.addClass('bg-page-1');
				break;

			case 3:
				container.addClass('bg-page-3');
				break;

			default:
				container.removeClass(function (index, container_elm) {
					return (container_elm.match (/(^|\s)bg-page-\S+/g) || []).join(' ');
				});
				break;

		}

	},

	goto_page : function(page_num) {

		for(var x = 0; x < 5; x++) {

			if(this.current_page < page_num) {

				// move right

				this.move_page_right();

			} else if (this.current_page > page_num) {

				// move left

				this.move_page_left();

			} else {

				// right on spot
				break;

			}

		}

	},

	get_url_var : function(var_name) {

		var url = new URL(window.location.href);

		return url.searchParams.get(var_name);

	},

	render_page_4_opt : function() {

		var container = $('.ji-skin-tone-opt');

		var desc = [

			'gold/yellow undertones',
			'balance of gold/yellow and pink undertones',
			'pink undertones'

		];

		var btn_label = [

			'WARM',
			'NEUTRAL',
			'COOL',

		];

		var html = '';

		$.each(this.page_4_opt, function(key, o) {

			// o = option
			// data-index="' + (key + 1 ) + '"

			html += '<li data-index="' + (key + 1 ) + '" style="background-color: ' + o.color + '">' + o.label + '<span class="font-24">&times;</span><ul class="ji-skin-tone-sub-opt">';

				$.each(o.options, function(k, color) {

					html += '<li data-index="' + (k + 1) + '">';

					if(color.indexOf(',') === -1) {

						// 1 color only

						html += '<div><div style="background-color: ' + color + '"></div></div>';

					} else {

						var colors = color.split(',');

						html += '<div><div style="background-color: ' + colors[0] + '"></div><div style="background-color: ' + colors[1] + '"></div></div>';

					}

					html += '<button>' + btn_label[k] + '</button><br/>';

					html += '<span>' + desc[k] + '</span>';

					html += '</li>';

				});
						
			html += '</ul></li>';

		});

		container.append(html);

	},

	toggle_page_4_opt : function(_this) {

		if($(_this).hasClass('expanded')) {

			$(_this).removeClass('expanded');

			return;

		}

		var container = $('.ji-skin-tone-opt');

		container.find('li').removeClass('expanded');

		$(_this).addClass('expanded');

	},

	toggle_selected_product : function(_this) {

		$(_this).toggleClass('selected');

		var sum_of_item = $('.ji-product-result li .selected').length;

		$('.ji-btn-add2cart span').text('('+sum_of_item+')');

	},

	update_user_input : function(n, index) {

		$('#ji-user-input input[name="q-'+n+'"]').val(index);

	},

	add_items_to_cart : function() {

      	var products = [];
      
		$('.ji-product-result li').each(function() {

			var li = $(this);

			if(li.find('.ji-custom-checkbox').hasClass('selected')) {

              	products.push({
              		quantity: 1,
	            	id: li.data('variant-id')
              	});

            } 

		});

      	$.post('/cart/add.js', {
          	items: products
        })
        .done(function() {
          	window.location.replace('/cart');
        })
        .fail(function(data) {
          console.log( 'Cart Add Error', data );
        });


	},

	reset_user_input : function() {

		$('#ji-user-input input[name^="q-"]').each(function() {

			$(this).val('');

		});
      
      	$('#ji-email-results-form p').empty();

	},

	find_products : function() {
      
      	JANE.set_loading_bar(0);

		var products = [];
		var prevent_user = false;
		var selected_opt = '';

		$('#ji-user-input input[name^="q-"]').each(function() {

			if($(this).val() == 0) {

				prevent_user = true;
				JANE.goto_page(parseInt($(this).data('nth-question')));
				return false;

			} else {

				selected_opt += $(this).val() + '-';

			}

		});

		if(prevent_user) {

			return;

		}
      
      	JANE.set_loading_bar(20);

		selected_opt = selected_opt.substr(0, selected_opt.length-1);

		$.post(this.server_url+'find_products.php', {combination: selected_opt}, JANE.get_product_info);

	},

	render_matched_products : function(product) {
      
      	var container = $('.ji-product-result');

		var html = '';

		$.each(product, function(key, prod) {
          
          	var variant_id = 0;
          	var variant_title = '';
          
	        $.each(prod.variants, function(k, variant) {
            
              	if(variant.sku == key) {
              
                  	variant_title = variant.title.toLowerCase() == 'default title' ? '' : variant.title;
                  	variant_id = variant.id;
                  
                  	return false;
              
              	}
            
            });

			html += '<li data-variant-id="'+variant_id+'">';
			html += '<img src="'+prod.featured_image +'" alt="'+prod.title+'">';
			html += '<div class="ji-custom-checkbox selected">&#10003;</div>';
			html += '<p><a href="/products/'+prod.handle+'?variant='+variant_id+'" target="_blank">'+prod.title+'</a></p><p>'+variant_title+'</p>';
			html += '</li>';

		});

		container.append(html);
      
      	JANE.set_loading_bar(JANE.loading_bar_val);
      	delete JANE.loading_bar_val;
      
      	JANE.num_of_products_received += 1;
        if(JANE.num_of_products === JANE.num_of_products_received) {

			JANE.set_loading_bar(100);
          
        }
      
      	var item_in_cart = $('.ji-product-result li .selected').length;
		$('.ji-btn-add2cart span').text('('+item_in_cart+')');

	},

	get_product_info : function(skus) {

		if(skus === 'false') {

			$('.ji-page-5 #no-products-found').show();
			$('.ji-page-5 #products-found').hide();
          
          	JANE.set_loading_bar(100);

		} else {

			$('.ji-page-5 #no-products-found').hide();
			$('.ji-page-5 #products-found').show();
          
          	JANE.set_loading_bar(40);
          
          	$('.ji-product-result').empty();
          
          	var products = skus.split(' ');
          
          	JANE.num_of_products = products.length;
          	JANE.num_of_products_received = 0;
          
          	$.ajaxSetup({ async: false });
          
			$.each(products, function(k, sku) {
              
              	JANE.loading_bar_val = ((50 / products.length) * (k+1)) + 40;
              
              	$.getJSON(JANE.store_url+'search.json?type=product&view=sku&q='+sku, JANE.render_matched_products);

			});
          
            $.ajaxSetup({ async: true });

		}

	}

};

$(document).ready(function() {

  	console.log('Initiating Foundation Finder app.');  
	JANE.init();
  	console.log('Foundation Finder app initiated.');

});


//show-hide mobile submenu 
$('.slideout-item').on('click', function() {
	var sel = this.getAttribute('data-toggle-target');
	$('.mobile-nav__sublist-wrapper').filter(sel).removeClass('hidden');
  });

  $('.submenu-close').on('click', function() {	
	$('.mobile-nav__sublist-wrapper').addClass('hidden');
  });































